// extracted by mini-css-extract-plugin
export default {"componentWrapper":"ErrorMessage_componentWrapper__otB+t"};